import { I18Namespaces } from '@dealstack/shared/lib/common/i18n/i18n.ts';
import { ContractType } from '@dealstack/shared/lib/generated';
import { TranslateFunction } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.types';

export const formatContractTypeLabel = (
	value: ContractType,
	tMipManage: TranslateFunction<I18Namespaces.MIP_MANAGE>
): string => {
	const labelMap: Record<ContractType, string> = {
		[ContractType.DEAL]: tMipManage('master_documents.text.deal'),
		[ContractType.SIDE_LETTER]: tMipManage('master_documents.text.side'),
		[ContractType.MULTISIGNATURE]: tMipManage('master_documents.text.multi_sign'),
		[ContractType.FORM]: tMipManage('master_documents.text.form'),
	};
	return labelMap[value] || value;
};
